<template>
    <!-- the expansion isn't smooth. the margins and paddings increase the height and width and v-expand-transition doesn't  seem to recognize that. -->
    <v-expand-transition>
        <v-card
            class="ml-0 pt-0 pb-0 rounded-0"
            flat
            color="rgb(255, 255, 255, 0.34)"
            max-width="500"
            max-height="150"
            style="overflow: auto;"
        >
            <v-list-item v-show="!comments.length" class="comment-color" style="text-align: center;">
                <v-list-item-subtitle class="comment-color">
                    Be the first one to comment!
                </v-list-item-subtitle>
            </v-list-item>
            <v-list-item v-for="comment in comments" :key="comment.id" class="pr-1 pb-0">
                <v-list-item-avatar size="26" style="align-self: start;">
                    <v-img :src="comment.user.profile.profile_image"></v-img>
                </v-list-item-avatar>
                <v-list-item-content class="pl-0 pb-0 white--text">
                    <v-bottom-sheet width="1200px" v-model="sheet">
                        <template v-slot:activator="{ on, attrs}">
                            <v-btn
                                class="pl-0 text-left"
                                color="transparent"
                                elevation="0"
                                v-bind="attrs"
                                v-model="sheet"
                                v-on="on"
                                x-small
                            >
                                <v-list-item-title class="author white--text text-caption">{{comment.user.first_name}} {{comment.user.last_name}}</v-list-item-title>
                            </v-btn>
                        </template>
                        <profilePage/>
                    </v-bottom-sheet>
                    <v-list-item-subtitle class="text-caption font-weight-medium wrap-text white--text">{{comment.text}}</v-list-item-subtitle>
                    <!--Will fix this later-->
                    <v-card-subtitle class="text-caption font-weight-light pa-0 white--text">
                        {{getCommentTime(comment.created)}}
                        <span>·</span>
                        <v-icon
                        size="16" 
                        @click="comment.liked=!comment.liked"
                        :color="comment.liked? 'red': 'white'"
                        >mdi-heart</v-icon>
                        6 Likes
                        <span>·</span>
                        {{comment.replies}}
                        <v-icon
                            color="white"
                            x-small
                            @click="showReplyTextArea"
                        >
                        Reply(s)
                        </v-icon>
                    </v-card-subtitle> 
                </v-list-item-content>
                    <v-icon
                    size="16" 
                    @click="comment.bookmark=!comment.bookmark"
                    :color="comment.bookmark? 'yellow': 'white'"
                    >mdi-clipboard-outline</v-icon>
            </v-list-item>
            <!--<addReply text-color="primary" v-if="showTextArea"/>-->
            <replySection v-if="showTextArea" :replies="replies"/>
            <v-divider></v-divider>
        </v-card>
    </v-expand-transition>
</template>
<script>
import { mapGetters, mapState } from 'vuex'
import profilePage from './profilePage'
import replySection from './replySection'
const moment = require('moment')
moment().format()
export default {
    data: () => ({
        showTextArea: false,
        showProfilePage: false,
        showReplies: false,
        sheet:"",
    }),
    computed: {
        ...mapState(['user']),
        ...mapGetters({user: "auth/user"}),
    },
    components: {
        profilePage,
        replySection,
    },
    props: {
        comments: Array,
        replies: Array,
    },
    methods: {
        reserve(){},
        showReplyTextArea(){
            this.showTextArea=!this.showTextArea;
        },
        toggleProfilePage() {
            this.showProfilePage=!this.showProfilePage;
        },
        getCommentTime(commentPublishedDate) {
            // Get todays date and the published date and find out how long
            // it's being since the comment was posted.
            //
            //const m1 = new Date(); // prints: Toady's date
            const m2 = new Date(commentPublishedDate) // prints: Date of comment
            const timeFromNow = moment(m2).fromNow() // Returns date that comment was created
            return timeFromNow
        },
    },
}
</script>

// used css for custom scrollbar and a couple of classes.
<style scoped>
    ::-webkit-scrollbar {
    width: 10px;
    height: 12px;
    }
    ::-webkit-scrollbar-track {
    background: #f5f5f5;
    border-radius: 10px;
    }
    ::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background: #ccc;  
    }
    ::-webkit-scrollbar-thumb:hover {
    background: #999;  
    }
    .wrap-text {
    white-space: normal;
    }/* To avoid the dots appering on the ending of the comments  */
    .comment-color {
        color: #FFF !important;
        font-family: sans-serif;
        font-size: 0.8rem;
        font-weight: 600;
    }
    .author {
        font-family: sans-serif;
        font-size: 1.1rem;
        font-weight: 900;
    }
</style>